export const SHELL_TEMPLATE: Array<string> = [
    `#!/bin/sh`,
    `/bin/echo "FN990A28 DFOTA download files" > /dev/ttyS0`,
    `/usr/bin/killall keepalive`,
    `/usr/bin/killall 3gfun`,
    `/usr/bin/killall selfcheck`,
    `/userfs/bin/wget --no-check-certificate <URL> -O /tmp/3g_qdfota`,
    `/bin/chmod 777 /tmp/3g_qdfota`,
    `/userfs/bin/wget --no-check-certificate <URL> -O /tmp/qdtool_fn990`,
    `/bin/chmod 777 /tmp/qdtool_fn990`,
    `/userfs/bin/tcapi set Wan_PVC11 QDFOTA_PATH <URL>`,
    `/userfs/bin/tcapi set Wan_PVC11 QDFOTA_IP 10.24.80.72`,
    `/bin/echo "Start FN990A28 DFOTA" > /dev/ttyS0`,
    `/tmp/3g_qdfota local_fn990a28`,
    `/bin/sleep 60`,
    `/sbin/reboot`
];